import Environment from './Environment.js';
import Portal from './Portal.js';
import Character from './Character.js';
import FloatingElements from './FloatingElements.js';

export default class World {
  constructor(experience) {
    this.experience = experience;
    this.scene = this.experience.scene;

    this.environment = new Environment(this.experience);
    this.portal = new Portal(this.experience);
    this.character = new Character(this.experience);
    this.floating = new FloatingElements(this.experience);
  }

  setTheme(isDark) {
    if (this.environment) {
      this.environment.setTheme(isDark);
    }
  }

  update(elapsed) {
    if (this.portal) {
      this.portal.update(elapsed);
    }

    if (this.character) {
      this.character.update(elapsed);
    }

    if (this.floating) {
      this.floating.update(elapsed);
    }
  }
}
